import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper";
import CardLink from "./Components/CardLink";
import { inject, observer } from "mobx-react";
import { pipe } from "Utils/functionalUtils";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = theme => {
    return {
        CardsLink: {
            fontFamily: theme.fonts.medium,
            backgroundColor: theme.palette.colors.paleGrey,
            padding: "60px 62px",
        },
        CardsLinkTitle: {
            fontFamily: theme.fonts.bold,
            color: theme.palette.colors.darkSlateBlue2,
            fontSize: "18px",
            lineHeight: "18px",
            letterSpacing: "2px",
            textTransform: "uppercase",
            textAlign: "center",
            marginBottom: "40px",
        },
        CardsLinkSwiper: {
            position: "relative",
            width: "100%",
            height: "auto",
            "&.swiper-container": {},
            "& > .swiper-wrapper": {},
            "&.swiper-container-horizontal>.swiper-pagination-bullets": {
                width: "100%",
                display: "none",
            },
            "& .swiper-pagination-bullet-active": {
                backgroundColor: theme.palette.colors.purplishBlue,
            },
        },
        buttonPrev: {
            color: theme.palette.colors.purplishBlue,
            position: "absolute",
            top: "50%",
            left: "25px",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
        },
        buttonNext: {
            color: theme.palette.colors.purplishBlue,
            position: "absolute",
            top: "50%",
            right: "-25px",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
        },
        CardsLinkContainer: {
            position: "relative",
            padding: "0 68px",
        },
        buttonDisabled: {
            color: theme.palette.colors.disabled,
        },
        CardsLinkSwiperSlide: {},
        [`@media (min-width: ${theme.media.lg})`]: {
            CardsLinkSwiperSlide: {
                "&.swiper-slide": {
                    height: "408px",
                    width: "280px",
                },
            },
        },
        [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
            CardsLinkSwiperSlide: {
                "&.swiper-slide": {
                    height: "392px",
                    width: "300px",
                },
            },
            buttonPrev: {
                display: "block",
            },
            buttonNext: {
                display: "block",
            },
        },
        [`@media (max-width: ${theme.media.md})`]: {
            CardsLinkSwiperSlide: {
                "&.swiper-slide": {
                    width: "230px",
                    height: "392px",
                },
            },
            CardsLink: {
                padding: "53px 0",
            },
            CardsLinkContainer: {
                padding: 0,
            },
            CardsLinkSwiper: {
                padding: 0,
                "& > .swiper-wrapper": {
                    paddingBottom: "55px",
                },
                "&.swiper-container-horizontal>.swiper-pagination-bullets": {
                    display: "block",
                },
            },
            buttonPrev: {
                display: "none",
            },
            buttonNext: {
                display: "none",
            },
        },
        [`@media (max-width: 800px)`]: {
            CardsLinkTitle: {
                fontSize: "14px",
            },

            CardsLinkSwiperSlide: {
                "&.swiper-slide": {
                    width: "230px",
                    height: "392px",
                },
            },
        },
        [`@media (min-width: 500px) and (max-width: ${theme.media.md})`]: {
            CardsLink: {
                padding: "53px 20px",
            },
        },
        [`@media (max-width: ${theme.media.xs})`]: {
            CardsLinkTitle: {
                marginBottom: "23px",
            },
            CardsLinkSwiperSlide: {
                "&.swiper-slide": {
                    width: "280px",
                    height: "364px",
                },
            },
        },
    };
};

SwiperCore.use([Pagination, Navigation]);

const CardsLink = props => {
    let {
        ApplicationModel: {
            windowSizeModel: { windowSizes },
            searcheModel,
            commonViewModel,
        },
        declinations,
        classes,
        data,
        place,
        defaultItems,
    } = props;

    let swiperRef = useRef();

    const [isEnd, setIsEnd] = useState(false);
    const [isBeginning, setIsBeginning] = useState(true);
    const [slidesCount, setSlidesCount] = useState(0);
    const [buttonShow, setButtonShow] = useState(true);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.on("reachEnd", () => {
                setIsEnd(true);
                setIsBeginning(false);
            });
            swiperRef.current.on("reachBeginning", () => {
                setIsEnd(false);
                setIsBeginning(true);
            });
        }
    }, [isEnd, isBeginning]);

    useEffect(() => {
        if (
            (windowSizes.lg && slidesCount <= 4) ||
            (windowSizes.md && slidesCount <= 3)
        ) {
            setButtonShow(false);
        } else {
            setButtonShow(true);
        }
    }, [slidesCount]);

    let layoutPlace = place === "улицы" ? `${place}` : "адреса";

    let list = data.map(elem => {
        let url;
        let house = elem.house ? `д. ${elem.house}` : "";
        let building = elem.building ? `к. ${elem.building}` : "";
        let construction = elem.construction ? `стр. ${elem.construction}` : "";
        let id = elem.id;
        let needDefaultItem = defaultItems?.find(item => item.id === id);
        url = needDefaultItem.link;
        let adress = elem.full
            ? elem.full
            : `${elem.street.full} ${house} ${building} ${construction}`;

        return (
            <SwiperSlide className={classes.CardsLinkSwiperSlide} key={elem.id}>
                <CardLink
                    id={elem.id}
                    place={place}
                    adress={adress}
                    url={url}
                    avg_speed={elem.avg_speed}
                    avg_price={elem.avg_price}
                    price_diff={elem.price_diff ? elem.price_diff : null}
                    review={elem.review}
                    likes={elem.likes}
                    dislikes={elem.dislikes}
                    providers={elem.providers}
                    searcheModel={searcheModel}
                    commonViewModel={commonViewModel}
                    // onClickHandler={needDefaultItem.onClickHandler}
                />
            </SwiperSlide>
        );
    });

    return (
        <div className={classes.CardsLink}>
            <div className={classes.CardsLinkTitle}>
                другие {layoutPlace}{" "}
                <nobr>в {declinations?.prepositional}</nobr>
            </div>
            <div className={classes.CardsLinkContainer}>
                <Swiper
                    onBeforeInit={swiper => {
                        swiperRef.current = swiper;
                    }}
                    slidesPerView={4}
                    spaceBetween={20}
                    initialSlide={0}
                    pagination={{ clickable: true }}
                    className={classes.CardsLinkSwiper}
                    watchOverflow={true}
                    onSwiper={swiper => setSlidesCount(swiper.slides.length)}
                    breakpoints={{
                        1440: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                            centeredSlides: false,
                            allowTouchMove: false,
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            centeredSlides: false,
                            allowTouchMove: false,
                        },
                        1199: {
                            slidesPerView: "auto",
                            spaceBetween: 10,
                            centeredSlides: false,
                            allowTouchMove: false,
                        },
                        800: {
                            slidesPerView: "auto",
                            spaceBetween: 10,
                            centeredSlides: false,
                            initialSlide: 1,
                        },
                        501: {
                            slidesPerView: "auto",
                            spaceBetween: 15,
                            centeredSlides: false,
                            initialSlide: 1,
                        },
                        360: {
                            slidesPerView: "auto",
                            spaceBetween: 15,
                            centeredSlides: true,
                            initialSlide: 2,
                        },
                    }}
                >
                    {list}
                </Swiper>
                {buttonShow && (
                    <>
                        <div
                            className={classNames(classes.buttonPrev, {
                                [classes.buttonDisabled]: isBeginning,
                            })}
                            onClick={() => swiperRef.current?.slidePrev()}
                        >
                            <svg
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_766_6549)">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M24 47.999C37.233 47.999 48 37.233 48 23.999C48 10.766 37.233 -0.000976562 24 -0.000976562C10.767 -0.000976562 0 10.766 0 23.999C0 37.233 10.767 47.999 24 47.999ZM24 2.00002C36.131 2.00002 46 11.869 46 23.999C46 36.131 36.131 46 24 46C11.869 46 2 36.131 2 23.999C2 11.869 11.869 2.00002 24 2.00002ZM27.293 34.707C27.488 34.902 27.744 35 28 35C28.256 35 28.512 34.902 28.707 34.707C29.098 34.316 29.098 33.683 28.707 33.293L19.414 23.999L28.707 14.707C29.098 14.316 29.098 13.684 28.707 13.293C28.316 12.902 27.684 12.902 27.293 13.293L17.293 23.292C16.902 23.683 16.902 24.316 17.293 24.706L27.293 34.707Z"
                                        fill="currentColor"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_766_6549">
                                        <rect
                                            width="48"
                                            height="48"
                                            fill="white"
                                            transform="matrix(-1 0 0 1 48 0)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div
                            className={classNames(classes.buttonNext, {
                                [classes.buttonDisabled]: isEnd,
                            })}
                            onClick={() => swiperRef.current?.slideNext()}
                        >
                            <svg
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_766_6547)">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M24 47.999C10.767 47.999 0 37.233 0 23.999C0 10.766 10.767 -0.000976562 24 -0.000976562C37.233 -0.000976562 48 10.766 48 23.999C48 37.233 37.233 47.999 24 47.999ZM24 2.00002C11.869 2.00002 2 11.869 2 23.999C2 36.131 11.869 46 24 46C36.131 46 46 36.131 46 23.999C46 11.869 36.131 2.00002 24 2.00002ZM20.707 34.707C20.512 34.902 20.256 35 20 35C19.744 35 19.488 34.902 19.293 34.707C18.902 34.316 18.902 33.683 19.293 33.293L28.586 23.999L19.293 14.707C18.902 14.316 18.902 13.684 19.293 13.293C19.684 12.902 20.316 12.902 20.707 13.293L30.707 23.292C31.098 23.683 31.098 24.316 30.707 24.706L20.707 34.707Z"
                                        fill="currentColor"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_766_6547">
                                        <rect
                                            width="48"
                                            height="48"
                                            fill="white"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default pipe(
    observer,
    inject("ApplicationModel")
)(withStyles(styles)(CardsLink));
